<template>

  <b-container @click="closeNavDropdowns" fluid clas="px-0" style="padding-bottom: 100px;" :class="{ 'pos-absolute': modalActive }">

    <the-hamburger class="text-white d-lg-none" style="position: fixed; z-index: 220; right: 15px; top: 10px;"></the-hamburger>
    <the-support style="width: 100%; position: absolute; z-index: 350;" v-if="supportActive"/>
    <the-overlay v-bind:style="{ height: this.$store.state.windowHeight + 'px' }" class="w-100" v-show="modalActive"/>
    <!-- <the-black-bar class="d-none d-md-block"></the-black-bar> -->
    <the-nav/>
    <the-sub-nav :newsletterUrl="newsletterUrl" :enrollmentUrl="enrollmentUrl"></the-sub-nav>
    <the-admin-bar v-show="loggedIn"></the-admin-bar>
    <router-view :newsletterUrl="newsletterUrl"/>
    <the-footer/>

  </b-container>

</template>

<script>

import TheHamburger from '@/components/TheHamburger.vue'
import TheSupport from '@/components/TheSupport.vue'
import TheOverlay from '@/components/TheOverlay.vue'
// import TheBlackBar from '@/components/TheBlackBar.vue'
import TheAdminBar from '@/components/TheAdminBar.vue'
import TheNav from '@/components/TheNav.vue'
import TheSubNav from '@/components/TheSubNav.vue'
import TheFooter from '@/components/TheFooter.vue'

export default {
  name: 'app',

  // vue-meta plugin stuff is injected here
  metaInfo: {
    //  title: 'Honda Digital Customer Experience',
     titleTemplate: '%s | Acura Digital Dealer Program'
   },

  components: {
    TheHamburger,
    TheSupport,
    TheOverlay,
    // TheBlackBar,
    TheAdminBar,
    TheNav,
    TheSubNav,
    TheFooter
  },

  data() {
    return {
      newsletterUrl: '',
      enrollmentUrl: this.$store.state.data.enrollmentPortalUrl,
    };
  },

  watch: {
    '$route.params': function ()
    {
      this.getNewsletterUrl();
    },
  },

  created() {
    // this.checkForceUpdate();
    // this.getNewsletterUrl();
  },

  methods: {

    getNewsletterUrl() {

      let self = this;
      this.$store.commit('generateApiCreds');
      this.$axios.get(process.env.VUE_APP_API_PATH + 'newsletters', {
          // auth: {
          //   username: this.$store.state.auth.apiUsername,
          //   password: this.$store.state.auth.apiPassword,
          // }
        })
        .then(resp =>
        {
          if( resp.data.length > 0 ){
            self.newsletterUrl = resp.data[resp.data.length - 1].url;
          }
        })
        .catch(() => {
          // Handle API errors silently
        });
    },

    closeEverything() {
      this.$store.commit("closeEverything");
    },

    closeNavDropdowns({ target }) {
      if(target.classList[0] != 'nav-link') {
        this.$store.commit("closeNavDropdowns");
      }
    },

  },

  computed: {
    
    modalActive() {
      return this.$store.state.modalActive ? true : false;
    },

    supportActive() {
      return this.$store.state.supportActive ? true : false;
    },

    loggedIn() {
      return this.$store.getters.loggedIn ? true : false;
    },

    showSubNav() {
      return this.$route.query.subnav ? true : false;
    },
  }

}

</script>

<style>

  @import 'assets/css/subnav.css';

  html,
  body,
  #app {
    overflow-x: clip;
    max-width: 100%;
  }

  .container-fluid {
    font-family: inherit;
    padding-left: 0 !important;
    padding-right: 0 !important;
    max-width: 100%;
  }

  .pos-absolute {
    position: absolute;
  }

  .btn-acura-primary {
    font-size: 14px;
    font-weight: 600;
    padding: 14px;
    background: linear-gradient(to right, black 50%,transparent 0);
    background-color: #e82c2a;
    background-position: right bottom;
    background-size: 300% 100%;
    transition: all .3s ease;
    color: white;
    border: 0px;
  }

  .btn-acura-primary:hover {
    background-position: left bottom;
    color: white;
  }

  .btn-acura-secondary {
    font-size: 14px;
    font-weight: 600;
    padding: 12px;
    background: linear-gradient(to right,#e82c2a 50%,transparent 0);
    background-color: white;
    background-position: right bottom;
    background-size: 300% 100%;
    transition: all .3s ease;
    color: black;
    border: 2px solid #e82c2a;
  }

  .btn-acura-secondary:hover {
    background-position: left bottom;
    color: white;
    border: 2px solid #e82c2a;
  }

  .btn-delete {
    color: #dc3545;
    padding: 5px;
  }

  .btn-delete:hover {
    color: white;
    border-radius: 5px;
    background-color: #dc3545;
    text-decoration: none;
  }

  .pre-line {
    white-space: pre-line;
  }

</style>
